import { dispatchData } from '@/api/dispatch'
import { num, pick, rowsOf } from '@/domain/extract'

export interface AppNotification {
  id: number
  title: string
  body: string
  createdAt: string | null
  seen: boolean
  raw: Record<string, unknown>
}

function toNotification(r: Record<string, unknown>): AppNotification {
  return {
    id: num(pick(r, 'notificationID', 'id')) ?? 0,
    title: String(pick(r, 'title', 'subject', 'notificationTitle') ?? ''),
    body: String(pick(r, 'body', 'message', 'notificationText', 'details') ?? ''),
    createdAt: (pick<string>(r, 'createdDate', 'createDate', 'transDate', 'date') ?? null),
    seen: Boolean(pick(r, 'isSeen', 'seen', 'isRead')),
    raw: r,
  }
}

export const notificationService = {
  async count(signal?: AbortSignal): Promise<number> {
    const data = await dispatchData<unknown, 'get', '/api/Notifications/GetCount'>('get', '/api/Notifications/GetCount', { signal })
    return typeof data === 'number' ? data : (num(pick(data, 'count', 'unseenCount', 'total')) ?? rowsOf(data).length)
  },
  async latest(count = 50, signal?: AbortSignal): Promise<AppNotification[]> {
    const data = await dispatchData<unknown, 'get', '/api/Notifications/GetLast/{DataCount}'>('get', '/api/Notifications/GetLast/{DataCount}', { params: { DataCount: count }, signal })
    return rowsOf<Record<string, unknown>>(data).map(toNotification)
  },
  async markSeen(id: number) {
    await dispatchData('get', '/api/Notifications/MarkSeen/{NotificationID}', { params: { NotificationID: id } })
  },
}
